module.exports = __webpack_public_path__ + "dsf_logo.png?f9458b20930fea685a50dd53ae44814d";